const almas_terms = `
<div>Last updated: 30/04/2026 </div>

<div>Please read these terms and conditions carefully before using Our Service.</div>

<div>1. Definitions</div>

<p>For the purposes of these Terms and Conditions:

Application means the software program, provided by the ALMAS downloaded by you on any electronic device.

Application Store means the digital distribution service operated and developed by Apple Inc. (Apple App Store) or Google Inc. (Google Play Store) from which the Application has been downloaded.

Affiliate means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.

- Country refers to: India

- ALMAS (referred to as either "ALMAS", "We", "Us" or "Our" in this Agreement) refers to ALMAS Hospital, Kottakkal, Malappuram, Kerala
</p>

<div>2. Acknowledgment</div>

<p>These are the Terms and Conditions governing the use of this Service and the agreement that operates between you and the ALMAS. These Terms and Conditions set out the rights and obligations of all users regarding the use of the service.

Your access to and use of the service is conditioned on your acceptance of and compliance with these Terms and Conditions. These Terms and Conditions apply to all visitors, users, and others who access or use the Service.

By accessing or using the service, you agree to be bound by these Terms and Conditions. If you disagree with any part of these Terms and Conditions then you may not access the Service.

Your access to and use of the Service is also conditioned on your acceptance of and compliance with the Privacy Policy of the Company. Our Privacy Policy describes our policies and procedures on the collection, use and disclosure of your personal information when you use the Application or the Website and tells you about your privacy rights and how the law protects you. Please read our Privacy Policy carefully before using our service.
</p>

<div>3. Links to Other Websites</div>

<p>Our Service may contain links to third-party web sites or services that are not owned or controlled by ALMAS

ALMAS has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third-party web sites or services. You further acknowledge and agree that ALMAS shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods or services available on or through any such web sites or services.

We strongly advise you to read the terms and conditions and privacy policies of any third-party web sites or services that You visit.
</p>

<div>4. Termination</div>

<p>We may terminate or suspend Your access immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms and Conditions.

Upon termination, your right to use the Service will cease immediately.
</p>

<div>5. Limitation of Liability</div>

<p>Notwithstanding any damages that you might incur, the entire liability of ALMAS and any of its suppliers under any provision of this Terms and your exclusive remedy for all of the foregoing shall be limited to the amount actually paid by you through the Service

To the maximum extent permitted by applicable law, in no event shall ALMAS or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, loss of data or other information, for business interruption, for personal injury, loss of privacy arising out of or in any way related to the use of or inability to use the Service, third-party software and/or third-party hardware used with the Service, or otherwise in connection with any provision of this Terms), even if ALMAS or any supplier has been advised of the possibility of such damages and even if the remedy fails of its essential purpose.

Some states do not allow the exclusion of implied warranties or limitation of liability for incidental or consequential damages, which means that some of the above limitations may

not apply. In these states, each party's liability will be limited to the greatest extent permitted by law.
</p>

<div>6. "AS IS" and "AS AVAILABLE" Disclaimer</div>

<p>The Service is provided to You "AS IS" and "AS AVAILABLE" and with all faults and defects without warranty of any kind. To the maximum extent permitted under applicable law, the Company, on its own behalf and on behalf of its Affiliates and its and their respective licensors and service providers, expressly disclaims all warranties, whether express, implied, statutory or otherwise, with respect to the Service, including all implied warranties of merchantability, fitness for a particular purpose, title and non-infringement, and warranties that may arise out of course of dealing, course of performance, usage or trade practice.</p>

<div>7. Governing Law</div>

<p>The laws of the Country, excluding its conflicts of law rules, shall govern this Terms and Your use of the Service. Your use of the Application may also be subject to other local, state, national, or international laws.</p>

<div>8. Disputes Resolution</div>

<p>If You have any concern or dispute about the Service, You agree to first try to resolve the dispute informally by contacting the ALMAS Hospital

These terms are governed by Laws of India. Any dispute arising shall be subject to the exclusive jurisdiction of the courts in India.</p>

<div>12. Severability and Waiver</div>

<p>Severability If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.

Waiver Except as provided herein, the failure to exercise a right or to require performance of an obligation under these Terms shall not affect a party's ability to exercise such right or require such performance at any time thereafter nor shall the waiver of a breach constitute a waiver of any subsequent breach.</p>

<div>13. Translation Interpretation</div>

<p>These Terms and Conditions may have been translated if We have made them available to you on our Service. You agree that the original English text shall prevail in the case of a dispute.</p>

<div>14. Changes to these Terms and Conditions</div>

<p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will make reasonable efforts to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at Our sole discretion.</p>

<div>15. Processing and card issuing bank policies.</div>

<p>Important: By submitting a payment through an online payment site, you are agreeing to these terms and conditions including any updated changes in terms and conditions from time to time through our website.</p>

<div>16. Contact Us</div>

<p>If you have any questions about these Terms and Conditions, you can contact us:

By email: finance@almashospital.com, 

By visiting this page on our website: https://almashospital.com, 

By phone number: 0483 2809100</p>
`
export default almas_terms;